// eslint-disable-next-line no-unused-vars
import React from 'react';
import { bool, func, object, string } from 'prop-types';
import {
  Checkbox,
  ModalFooter,
  TextInput
} from '@carbon/react';
import { useTheme } from '@emotion/react';
import { useTranslation } from 'react-i18next';

import ProductPreview from './ProductPreview';
import {
  ContentForm,
  PrimaryButton,
  SecondaryButton,
  SubmitLoading
} from './ContentStyles';

const CreateWishlistContent = ({
  product,
  name,
  isDefault,
  error,
  loading,
  onNameChange,
  onSetDefault,
  onSubmit,
  onCancel
}) => {
  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <ContentForm theme={ theme } onSubmit={ onSubmit }>
      <div className="wrapper">
        <ProductPreview product={ product } />
        <div className="section-heading">
          <p>{ t('offers.createNewList') }</p>
        </div>
        <TextInput
          required
          id="createDestinationWishlistName"
          name="name"
          labelText={ t('wishlists.listName') }
          placeholder={ t('wishlist.placeholder') }
          value={ name }
          invalid={ !!error }
          invalidText={ error }
          disabled={ loading }
          onChange={ onNameChange }
        />
        <Checkbox
          id="createDestinationWishlistDefault"
          labelText={ t('wishlist.isDefault') }
          checked={ isDefault }
          disabled={ loading }
          onChange={ (_, { checked }) => onSetDefault(checked) }
        />
      </div>
      <ModalFooter>
        <PrimaryButton className="red submit" type="submit" disabled={ loading || !!error }>
          { loading && <SubmitLoading status="active" /> }
          { t('wishlists.createList') }
        </PrimaryButton>
        <SecondaryButton kind="ghost" onClick={ onCancel } disabled={ loading }>
          { t('common.cancel') }
        </SecondaryButton>
      </ModalFooter>
    </ContentForm>
  );
};

CreateWishlistContent.propTypes = {
  product: object,
  name: string,
  isDefault: bool,
  error: string,
  loading: bool,
  onNameChange: func,
  onSetDefault: func,
  onSubmit: func,
  onCancel: func
};

export default CreateWishlistContent;
